module.exports = __webpack_public_path__ + "static/media/calendar.7ac4e987.svg";